import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=4b5bdc4f&scoped=true&"
import script from "./Updates.vue?vue&type=script&lang=js&"
export * from "./Updates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5bdc4f",
  null
  
)

export default component.exports